import { FC } from 'react';
import { useIntl } from 'react-intl';
import { RSNote } from 'src/reservation-page/RSNote';
import { SpinnerIcon } from '@stpkg/stand-react';

export const ProcessingTemplate: FC = () => {
  const intl = useIntl();
  return (
    <div>
      {/* RSDetailHeader を使うと、 mobile で文字数が多い場合 truncate されてしまうため RSDetailHeader を使わない */}
      <div className="z-5 border-gray-10 sticky top-0 border-b-[3px] border-solid bg-white">
        <div className="box-border flex h-[59px] w-full items-center justify-center px-1">
          <div className="rs-font text-16 text-gray-1000 pc:text-15 pc:leading-[1.4] text-center font-bold leading-[1.4]">
            {intl.formatMessage({
              defaultMessage: '決済を処理しています',
              id: 'KUW+aG',
              description:
                'src/templates/merchants/resources/book/event_type/ProcessingTemplate/index.tsx',
            })}
          </div>
        </div>
      </div>

      <div className="mx-auto mt-3 box-border max-w-[560px] px-2.5 pb-9">
        <RSNote
          variant="caution"
          body={intl.formatMessage({
            defaultMessage:
              'エラーを防ぐため、画面を移動したり閉じたりしないでください。',
            id: 'n/CxLe',
            description:
              'src/templates/merchants/resources/book/event_type/ProcessingTemplate/index.tsx',
          })}
        />
        <div className="mt-[120px] text-center">
          <SpinnerIcon
            width="56"
            height="56"
            viewBox="0 0 48 48"
            className="fill-gray-200 opacity-100 transition"
          />
        </div>
        <div className="rs-font text-16 pc:text-15 text-gray-1000 mt-2 text-center font-normal">
          {intl.formatMessage(
            {
              defaultMessage:
                'このまましばらくお待ちください。<br></br>完了すると自動で画面が切り替わります。',
              id: 'h5ywU+',
              description:
                'src/templates/merchants/resources/book/event_type/ProcessingTemplate/index.tsx',
            },
            {
              br: () => <br></br>,
            },
          )}
        </div>
      </div>
    </div>
  );
};
